import styles from './TerminateSideCard.module.scss'
import TerminateCardContent from './TerminateCardContent.tsx'
import useWindowSize from 'hooks/useWindowSize.tsx'
import { useStoreSelector } from 'hooks/store.ts'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { Card, Icon, Modal } from '@boltenergy-be/design-system'
import { formatAddress } from 'utils/user.ts'
import { selectCurrentServiceContracts } from 'store/contact/slice.ts'

const TerminateSideCard = () => {
  // Redux
  const serviceContracts = useStoreSelector(selectCurrentServiceContracts)

  // i18n
  const { t } = useTranslation('contracts')

  // Window size
  const { isTablet } = useWindowSize()

  // Local state
  const [showMobileDrawer, setShowMobileDrawer] = useState<boolean>(false)

  // Constants
  const { address } = serviceContracts.electricity.deliveryPoint

  return isTablet ? (
    <>
      <Card as="button" className={styles['sticky-footer-card']} onClick={() => setShowMobileDrawer(true)}>
        <strong>{t(($) => $.terminate.sideCard.address)}</strong>
        <address className={styles.address}>{formatAddress(address)}</address>

        <Icon name="chevronUp" className={styles['toggle-icon']} />
      </Card>

      <Modal className={styles.drawer} isOpen={showMobileDrawer} onRequestClose={() => setShowMobileDrawer(false)}>
        <TerminateCardContent selectedContracts={serviceContracts} />
      </Modal>
    </>
  ) : (
    <Card as="aside" className={styles.card}>
      <TerminateCardContent selectedContracts={serviceContracts} />
    </Card>
  )
}

export default TerminateSideCard
